import { useEffect, useRef } from "react";

/**
 * Reset paramsQuery khi tab thay đổi (bỏ qua lần mount đầu).
 */
export default function useResetParamsOnTabChange(tab, setParamsQuery, initialValue = undefined) {
  const isFirstRender = useRef(true);
  const initialValueRef = useRef(initialValue);

  initialValueRef.current = initialValue;

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const next = initialValueRef.current;
    setParamsQuery(typeof next === "function" ? next() : next);
  }, [tab, setParamsQuery]);
}
